'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CheckboxButton = function (_Component) {
  (0, _inherits3.default)(CheckboxButton, _Component);

  function CheckboxButton(props) {
    (0, _classCallCheck3.default)(this, CheckboxButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CheckboxButton.__proto__ || (0, _getPrototypeOf2.default)(CheckboxButton)).call(this, props));

    _this.state = {
      isChecked: _this.props.defaultChecked || _this.props.checked
    };
    return _this;
  }

  (0, _createClass3.default)(CheckboxButton, [{
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({
        isChecked: this.input.checked
      });
      this.props.onChange(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('label', {
        className: this.classes
      }, _react2.default.createElement('input', {
        type: 'checkbox',
        name: this.props.name,
        value: this.props.value,
        checked: this.state.isChecked,
        ref: function ref(c) {
          return _this2.input = c;
        },
        onChange: this.handleChange.bind(this)
      }), _react2.default.createElement('div', {
        className: 'Input-icon'
      }, _react2.default.createElement('i', {
        className: 'material-icons Input-icon-unchecked'
      }, 'check_box_outline_blank'), _react2.default.createElement('i', {
        className: 'material-icons Input-icon-checked'
      }, 'check_box')), _react2.default.createElement('div', {
        className: 'Input-content'
      }, _react2.default.createElement('div', {
        className: 'Input-text'
      }, this.titleNode, this.props.text && _react2.default.createElement('span', {
        className: 'Input-text-help'
      }, this.props.text)), this.props.secondaryTitle && _react2.default.createElement('div', {
        className: 'Input-secondaryTitle'
      }, this.props.secondaryTitle)));
    }
  }, {
    key: 'titleNode',
    get: function get() {
      if (this.props.isHtml) {
        var htmlObj = {
          __html: this.props.title
        };
        return _react2.default.createElement('span', {
          className: 'Input-text-main',
          dangerouslySetInnerHTML: htmlObj
        });
      } else {
        return _react2.default.createElement('span', {
          className: 'Input-text-main'
        }, this.props.title);
      }
    }
  }, {
    key: 'checked',
    get: function get() {
      return this.input.checked;
    }
  }, {
    key: 'classes',
    get: function get() {
      var className = 'Input Input--checkbox ' + this.props.className;

      if (this.state.isChecked) {
        className += ' is-checked';
      }

      return className;
    }
  }]);
  return CheckboxButton;
}(_react.Component);

CheckboxButton.propTypes = {
  checked: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  isHtml: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  secondaryTitle: _propTypes2.default.string,
  text: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.any.isRequired
};
CheckboxButton.defaultProps = {
  checked: false,
  defaultChecked: false,
  isHtml: false,
  name: '',
  onChange: function onChange() {},
  secondaryTitle: '',
  text: '',
  title: '',
  value: ''
};
exports.default = CheckboxButton;